import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

interface PublicSettings {
  site_title?: string
  [key: string]: unknown
}

export function useDocumentTitle() {
  const { data: settingsResponse } = useQuery({
    queryKey: ['public-settings'],
    queryFn: async () => {
      // Fetch from public settings endpoint (no auth required)
      const response = await fetch(
        `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'}/api/v1/settings`
      )
      if (!response.ok) throw new Error('Failed to fetch settings')
      return response.json() as Promise<{ data: PublicSettings }>
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    retry: false, // Don't retry on failure
    refetchOnWindowFocus: false, // Don't refetch on window focus
    // Silently fail - don't throw errors that could break the UI
    throwOnError: false,
  })

  useEffect(() => {
    const baseTitle = settingsResponse?.data?.site_title || 'ATP'
    // Extract just the main part of the title (before " | " or " - ")
    const shortTitle = baseTitle.split(' | ')[0] || baseTitle.split(' - ')[0] || baseTitle
    document.title = `Dashboard | ${shortTitle}`
  }, [settingsResponse?.data?.site_title])
}
